import { useTranslation } from "react-i18next"
import HasPermission, { CanViewCompanyLog } from "app/PermissionChecker"
import { useGetCompanyActivityStatsQuery } from "features/core/log/api/logApiSlice"
import ActivityStats from "./ActivityStats"
import { useEffect, useState } from "react"
import React from "react"

function CompanyActivityStats() {
    const [t, i18n] = useTranslation("global")
    const canViewCompanyLog = HasPermission(CanViewCompanyLog)
    const [selectedDays, setSelectedDays] = useState(14);
    const {
        data: statsData,
        isFetching: statsIsFetching,
        isSuccess: statsIsSuccess,
        isLoading: statsIsLoading,
        isError: statsIsError,
        error: statsError,
        refetch
    } = useGetCompanyActivityStatsQuery(selectedDays)


    // Refetch automatico su cambio filtro
    useEffect(() => {
        refetch(selectedDays);
    }, [selectedDays]);

    let content

    if (statsIsSuccess) {
        content = <ActivityStats data={statsData} isLoading={statsIsFetching} onChangeDaysNumber={setSelectedDays} />
    }
    return content
}

export default CompanyActivityStats